import React from 'react';
import { ExpenseClaimProvider } from '../../context/ExpenseClaimProvider';
import { ExpenseClaimUtilProvider } from '../../context/ExpenseClaimUtilProvider';
import EmployeeExpenseClaimsDetail from './EmployeeExpenseClaimsDetail';

export default function EmployeeExpenseClaimsDetailWrapper() {
  return (
    <ExpenseClaimUtilProvider>
      <ExpenseClaimProvider>
        <EmployeeExpenseClaimsDetail />
      </ExpenseClaimProvider>
    </ExpenseClaimUtilProvider>
  );
}
